import { api, apiEndpoint } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { CALORIE_GRID_SERVICE } from "../config/index.ts";

export const calorieGridApi = api(
  { domain: API_DOMAIN, path: `${CALORIE_GRID_SERVICE.LABEL}/api` },
  { ping: apiEndpoint({ response: z.object({}) }) },
);
